export const MIN_FICO_CREDIT_SCORE = 560
export const MIN_FICO_ENTIRE_HOUSE_CREDIT_SCORE = 600

export enum EPaymentErrorType {
  VALIDATION_ERROR = 'validation_error'
}
